import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";

import { Button, FormControl, MenuItem, Select, Stack } from "@mui/material";

import PropertyComponent from "./PropertyComponent";

import { api } from "../../../../../utils";
import { IError } from "../../../../../models/ReportPageModels";


interface GetClients {
    data: GetClientsData;
    error: IError;
}
interface GetClientsData {
    clients: MobileUserModel[];
}
interface MobileUserModel {
    userName: string;
    updateApplied: boolean;
}

export interface PropertyModel {
    propertyName: string;
    //propertyType : string;
    propertyValue: string;
}

export interface ConfigPropertyModel {
    name: string;
    type: "field" | "dropdown" | "array" | "special";
    values?: string[];
}

const configProperties: ConfigPropertyModel[] = [
    { name: "CsvUrl", type: "field" },
    { name: "UploadType", type: "dropdown", values: ["S3", "FTP", "SFTP"] },
    { name: "PhotoLabels", type: "array" },


    { name: "CsvDataSourceMapping", type: "special" },
    { name: "MaskFilename", type: "special" },
];

const configNames: string[] = configProperties.map((config) => config.name);

function EditMobileConfig() {
    const { enqueueSnackbar } = useSnackbar();

    const [clients, setClients] = useState<MobileUserModel[]>([]);

    const [selectedClient, setSelectedClient] = useState<string>("");
    const [updateApplied, setUpdateApplied] = useState<boolean>(true);

    const [properties, setProperties] = useState<PropertyModel[]>([]);

    const RemoveProperty = useCallback((prop: PropertyModel) => {
        const tempArray: PropertyModel[] = [];
        for (let i = 0; i < properties.length; i++) {
            if (properties[i] == prop)
                continue;
            tempArray.push(properties[i]);
        }
        setProperties(tempArray);
    }, [properties])

    useEffect(() => {
        GetClients();
    }, [])

    const GetClients = async () => {
        try {
            const response: GetClients = await api.get("api/Admin/GetMobileClients", {
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                setClients(response.data.clients);
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    function SetSelectedClient(event: any) {
        var value = event.target.value;
        setSelectedClient(value);

        // check if update applied
        for (let i = 0; i < clients.length; i++) {
            if (clients[i].userName === value) {
                setUpdateApplied(clients[i].updateApplied);
                // TODO: read partial update config file 
                break;
            }
        }
    }

    function AddProperty() {
        const newProperty: PropertyModel = {
            propertyName: "",
            propertyValue: ""
        };
        setProperties(current => [...current, newProperty]);
    }


    const ApplyConfig = async () => {
        console.log(properties);
    }

    return (
        <Stack>
            {/* Database names */}
            <Stack
                direction={"row"}
                alignItems={"center"}>
                <p style={{ width: '70px' }}>Client: </p>
                <FormControl sx={{ minWidth: "230px", width: "230px" }}>
                    <Select
                        value={selectedClient}
                        onChange={SetSelectedClient}
                        size="small"
                        defaultValue={""}>
                        {clients.map((client, index) =>
                            <MenuItem
                                key={index}
                                value={client.userName}>
                                {client.userName}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>

                <Button
                    variant="outlined"
                    onClick={() => ApplyConfig()}
                    sx={{ width: '200px', marginLeft: "10px" }}>
                    Apply partial config
                </Button>

                {/* display if update applied */}
                {!updateApplied ? <h3 style={{ color: "red", marginLeft: "20px" }}>Update not applied</h3> : null}
            </Stack>

            {/* Properties */}
            {properties.map((property, index) => (
                <PropertyComponent
                    key={index}
                    property={property}
                    configProperties={configProperties}
                    configNames={configNames}
                    remove={RemoveProperty} />
            ))}

            {/* Add button */}
            <Button
                variant="outlined"
                onClick={AddProperty}
                sx={{ width: "150px" }}>
                Add Property
            </Button>
        </Stack>
    )
}

export default EditMobileConfig;